import React from 'react';
import classnames from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { sliceToDivisible } from '../../SidebarBlock/layouts/helpers';
import s from './SidebarGrid.scss';
var thumbHeight = parseInt(s['sidebar-thumb-height']);
var thumbWidth = parseInt(s['sidebar-thumb-width']);
var itemsPerRow = 3;
var SidebarGrid = function (_a) {
    var items = _a.items, renderItem = _a.renderItem, _b = _a.maxRows, maxRows = _b === void 0 ? 3 : _b, className = _a.className;
    var maxItems = itemsPerRow * maxRows;
    var slice = sliceToDivisible(items, itemsPerRow, maxItems);
    return (React.createElement("div", { className: classnames(s['root'], className) }, slice.map(function (item, index) { return (React.createElement(BiLoggerContextProvider, { key: index, value: { _rankIndex: index } }, renderItem({
        item: item,
        width: thumbWidth,
        height: thumbHeight,
        className: s['grid-item'],
    }))); })));
};
SidebarGrid.displayName = 'SidebarGrid';
export default SidebarGrid;
//# sourceMappingURL=SidebarGrid.js.map